

import React from "react";
import { useParams, useLocation } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import { Navbar } from './navbar';
import { Button } from '@mui/material';
import SpecificationSection from './ProductSpecificationCard';
import FeatureBlockSection from "./ProductFeatureBlockSection";
import DownloadCard from "./ProductDownloadSection";
import RelatedProductYeastar from "./RelatedProductYeastar";
import FAQSection from './FQA';
import Footer from './footer';
import { Helmet } from "react-helmet";

const DetailPageYeastar = ({ allData }) => {
  const { permalink } = useParams();
  const location = useLocation();
  // Try to get the product from state
  const stateProduct = location.state;
  const allProducts = Object.values(allData).flat(); // Flatten the allData object if it's nested
  // Try to find from data if not in state (e.g., on refresh)
  const item = stateProduct || allProducts.find(
    (product) => (product.permalink).toLowerCase() === decodeURIComponent(permalink).toLowerCase());

  if (!item) {
    return (
      <Typography variant="h6" align="center" mt={5}>
        Product not found
      </Typography>
    );
  }

  return (
    <>
      <Helmet>
        <title>{item.metaTitle}</title>
        <meta name="description" content={item.metaDescription} />
        <meta name="keywords" content={item.metaKeywords} />
        
      </Helmet>
      <div>
        <Navbar variant='absolute' />
        <Box
          sx={{
            textAlign: "center",
            px: { xs: 2, sm: 4 },
            py: { xs: 3, sm: 5 },
            pt: { xs: '90px', sm: '110px' }, // Space below header
            maxWidth: 800,
            mx: "auto",
          }}
        >
          {/* Image */}
          <Box sx={{ mb: 3 }}>
            <img
              src={item.image}
              alt={item.name}
              style={{
                width: "100%",
                maxWidth: "400px",
                height: "auto",
                maxHeight: "370px",
                objectFit: "contain",
                backgroundColor: 'white'
              }}
            />
          </Box>

          {/* Name */}
           <Typography
                  variant="h1"
                  fontWeight="bold"
                  color="black"
                  gutterBottom
                  sx={{
                    fontSize: { xs: "1.8rem", sm: "2.2rem" },
                  }}
                >
                  {item.titlename}
            </Typography>

          {/* Details */}
          <Typography
            variant="body1"
            color="#555"
            gutterBottom
            sx={{
              fontSize: { xs: "0.95rem", sm: "1.05rem" },
              px: { xs: 1, sm: 4 },
            }}
          >
            {item.titletagline}
          </Typography>

          {/* Buy Now Button */}
          <Button
            variant="contained"
            component="a"
            href="https://wa.me/923005710318"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              mt: 4,
              backgroundColor: 'blue',
              color: 'white',
              borderRadius: '50px',
              px: 5,
              py: 1.5,
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: { xs: '14px', sm: '16px' },
              '&:hover': {
                backgroundColor: '#0044cc',
              },
            }}
          >
            Buy Now
          </Button>
        </Box>
        <SpecificationSection specs={item.Detailspagecards} />
        <FeatureBlockSection data={item} />
        <DownloadCard data={item} />
        <RelatedProductYeastar currentItem={item} />
        <FAQSection />
        <Footer />
      </div>
    </>
  );
};

export default DetailPageYeastar;
